import { Component, OnInit } from '@angular/core';
import {IonContent, IonRow} from '@ionic/angular/standalone';

@Component({
  selector: 'app-not-found-404',
  templateUrl: './not-found-404.component.html',
  styleUrls: ['./not-found-404.component.scss'],
  imports: [
    IonContent,
    IonRow
  ]
})
export class NotFound404Component  implements OnInit {

  constructor() { }

  ngOnInit() {}

}
